export default __webpack_public_path__ + "static/media/apsn.0bb2c3c5.png";